import {gql} from '@apollo/client'

// Admin: Twilio spend overview (this month total, by category, trend, balance).
export const TWILIO_ACCOUNT_USAGE = gql`
  query TwilioAccountUsage {
    twilioAccountUsage
  }
`

// Admin: every owned Twilio number with rental estimate, type and owning agent.
export const TWILIO_NUMBERS_INVENTORY = gql`
  query TwilioNumbersInventory {
    twilioNumbersInventory
  }
`

// Agent: their own rebilling for the month (rental + voice with markup).
export const MY_BILLING = gql`
  query MyBilling($year: Int, $month: Int) {
    myBilling(year: $year, month: $month)
  }
`

// Admin: per-agent rebilling report (cost / charge / margin).
export const ADMIN_BILLING_REPORT = gql`
  query AdminBillingReport($year: Int, $month: Int) {
    adminBillingReport(year: $year, month: $month)
  }
`

// Global rebilling markups (voice % + fixed rental).
export const BILLING_MARKUPS = gql`
  query BillingMarkups {
    billingMarkups
  }
`

// Admin: per-call detail for an agent's numbers (direction, other party, time, price w/ markup).
export const AGENT_CALL_DETAIL = gql`
  query AgentCallDetail($targetUserId: ID!, $year: Int, $month: Int) {
    agentCallDetail(targetUserId: $targetUserId, year: $year, month: $month)
  }
`
